import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useMemo } from 'react';
import purify from '../../../node_modules/dompurify/dist/purify.es.js';
import { Element, domToReact } from '../../../node_modules/html-react-parser/index.mjs.js';
import { useThemeProps } from '@mui/material';
import { parseInlineStyle } from '../../../modules/styling/utils.js';
import ExternalLink from '../../navigation/ExternalLink.js';
import htmlReactParser from '../../../node_modules/html-react-parser/index.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["href", "target", "rel", "style", "color"];
var componentRoot = createComponentSlot({
  name: "CinFormatHtml",
  slot: "Root"
});

var FormatHtmlBase = function FormatHtmlBase(_ref) {
  var value = _ref.value,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? null : _ref$fallback,
      _ref$replaceLinks = _ref.replaceLinks,
      replaceLinks = _ref$replaceLinks === void 0 ? true : _ref$replaceLinks,
      parserOptions = _ref.parserOptions;
  var content = useMemo(function () {
    if (!value) return null;
    var html = purify.sanitize(value);

    var options = _objectSpread2(_objectSpread2({}, parserOptions), {}, {
      replace: function replace(node) {
        if (parserOptions !== null && parserOptions !== void 0 && parserOptions.replace) {
          var replacement = parserOptions.replace(node);
          if (replacement !== undefined) return replacement;
        } // default behaviour to treat any <a> tags with href as external links


        if (replaceLinks && node instanceof Element && node.name === "a") {
          var _node$attribs = node.attribs,
              href = _node$attribs.href;
              _node$attribs.target;
              _node$attribs.rel;
              var style = _node$attribs.style;
              _node$attribs.color;
              var otherAttribs = _objectWithoutProperties(_node$attribs, _excluded);

          if (!href) return;
          var inlineStyle = parseInlineStyle(style);
          return /*#__PURE__*/React.createElement(ExternalLink, _extends({
            href: href,
            style: inlineStyle
          }, otherAttribs), domToReact(node.children, options));
        }
      }
    });

    return htmlReactParser(html, options);
  }, [value, replaceLinks, parserOptions]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, content || fallback);
};
/**
 * Formats a value as HTML
 */


FormatHtmlBase.propTypes = {
  value: propTypes.oneOfType([propTypes.string, propTypes.oneOf([null])]),
  fallback: propTypes.node,
  replaceLinks: propTypes.bool,
  parserOptions: propTypes.any
};

var FormatHtml = function FormatHtml(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(FormatHtmlBase, rootProps);
};

FormatHtml.propTypes = {
  value: propTypes.oneOfType([propTypes.string, propTypes.oneOf([null])]),
  fallback: propTypes.node,
  replaceLinks: propTypes.bool,
  parserOptions: propTypes.any
};
var FormatHtml$1 = FormatHtml;

export { FormatHtml$1 as default };
